import $ from "jquery";
import "bootstrap/js/dist/tab";
import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Set up Google autocomplete in the search modals
if (placesAutoComplete && document.querySelector(".js-video-profile-search-form-city-state")) {
  placesAutoComplete.initializeCityState(
    ".js-video-profile-search-form-city-state",
    null,
    pageData.get("currentCountry")
  );
}

if (placesAutoComplete && document.querySelector(".js-video-profile-search-form-address")) {
  placesAutoComplete.initializeAddress(
    ".js-video-profile-search-form-address",
    null,
    pageData.get("currentCountry")
  );
}

// This sets the color of the active tab to the brand's primary color
$("#video-product-nav-tabs a").on("click", e => {
  $("#video-product-nav-tabs a.active").removeClass("btn-primary");
  $(e.target).addClass("btn-primary");
});
